import { DataTypeEnum } from "shared/constants/app-enums";
import { SeoModel } from "shared/models/seo-model";
import { ProductModel } from "states/product/product.models";

export interface ProductCategoryModel {
  key: string;
  id: number;
  name: string;
  slug: string;
  avatar: string;
  filterSetting?: ProductFilterSetting;
  seoFields?: SeoModel;
  customizeTheme?: any;
  active: boolean;
  productCategoryModifierGroups: ProductCategoryModifierGroup[];
  attributeGroups: ProductCategoryProductAttributeGroupModel[];
  branchId?: number;
  sort: number;
}
export interface ProductCategoryModifierGroup {
  modifierGroupId?: number;
  productCategoryId?: number;
  isRequired: boolean;
  sort: number;
  selectType: SelectTypeEnum;
  productCategoryModifiers: ProductModel[];
}
export const SelectType = ["Single", "Multiple"];
export enum SelectTypeEnum {
  Single,
  Multiple,
}
export interface ProductCategoryProductAttributeGroupModel {
  attributeGroupId: number;
  attributeGroupName: string;
  sort: number;
  attributes: ProductCategoryProductAttributeModel[];
}

export class ProductCategoryProductAttributeModel {
  constructor() {
    this.attributeName = "";
    this.sort = 0;
    this.values = [];
  }

  attributeId?: number;
  attributeName: string;
  sort: number;
  dataType?: DataTypeEnum;
  valueNumber?: number;
  valueString?: string;
  valueBoolean?: boolean;
  valueDate?: Date;
  values: ProductCategoryProductAttributeValueModel[];

  resetValue() {
    this.values = [];
    this.valueNumber = undefined;
    this.valueString = undefined;
    this.valueBoolean = undefined;
    this.valueDate = undefined;
  }
}
export interface ProductCategoryProductAttributeValueModel {
  valueId: number;
  value: string;
  sort: number;
}
export interface ProductCategoryModifierModel {
  id: number;
  skuCode: string;
  images: string[];
  sellingPrice: number;
  name: string;
  slug: string;
  sort: number;
}

export interface UpdateProductCategoryModifierModel {
  productId: number;
  sort: number;
}
export interface UpdateProductCategoryModifierGroupModel {
  modifierGroupId: number;
  sort: number;
  selectType: SelectTypeEnum;
  isRequired: boolean;
  productCategoryModifiers: UpdateProductCategoryModifierModel[];
}
export interface CreateProductCategoryModel {
  name: string;
  slug: string;
  avatar: string;
  filterSetting?: any;
  active: boolean;
  seoFields?: SeoModel;
  customizeTheme?: string;
  productCategoryModifierGroups: UpdateProductCategoryModifierGroupModel[];
  attributeGroups: ProductCategoryProductAttributeGroupModel[];
  branchId?: number;
  sort: number;
}

export interface UpdatedProductCategoryModel {
  id: number;
  name: string;
  slug: string;
  avatar: string;
  filterSetting?: any;
  active: boolean;
  seoFields?: SeoModel;
  customizeTheme?: string;
  productCategoryModifierGroups: UpdateProductCategoryModifierGroupModel[];
  attributeGroups: ProductCategoryProductAttributeGroupModel[];
  sort: number;
}
export interface SearchProductCategoryRequestModel {
  name?: string;
  page: number;
  pageSize: number;
}

export interface ProductCategoryProductAttributeModel {
  productAttributeId: number;
  attributeName: string;
  logicalTerm: LogicalTermEnum;
  productAttributeValueIds: number[];
}
export interface ProductCategoryAttributeModel {
  productAttributeId: number;
  attributeName: string;
  logicalTerm: LogicalTermEnum;
  values: ProductCategoryProductAttributeValueModel[];
}
export interface ProductCategoryProductAttributeValueModel {
  valueId: number;
  value: string;
  sort: number;
}

export enum LogicalTermEnum {
  Or,
  And,
}
export interface ProductFilterSetting {
  priceFilters: ProductPriceFilterModel[];
  attributeFilters: ProductCategoryProductAttributeModel[];
}
export interface ProductCategoryFilterSettingModel {
  priceFilters: ProductPriceFilterModel[];
  attributeFilters: ProductCategoryAttributeModel[];
}

export interface ProductPriceFilterModel {
  priceFrom?: number;
  priceTo?: number;
  displayedText: string;
}
